import { useQuery } from '@apollo/client/react';
import { Query, QueryVehicleArgs } from '../../../@types/codegen/types';
import SEARCH_ITEM_BRANCH_QUERY from '../Queries/SEARCH_ITEM_BRANCH_QUERY';

const useSearchItemBranch = (id?: string | null, branch?: string | null) =>
  useQuery<Query, QueryVehicleArgs>(SEARCH_ITEM_BRANCH_QUERY, {
    variables: { id: id as string, branch: branch as string },
    skip: !id || !branch,
  });

export default useSearchItemBranch;
